<template>
  <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg">
    <div class="px-6">
      <div class="flex flex-wrap justify-center">
        <div class="w-full px-4 flex justify-center">
          <div class="relative">
            <img alt="..." :src="image"
              class="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px bg-white" />
          </div>
        </div>
        <div class="w-full px-4 mt-20">
          <div class="py-4 lg:pt-4 pt-8 text-center">
            <h6 class="text-blueGray-700 text-xl font-bold pt-8 mb-1">
              Roles
            </h6>
            <ul class="mb-4">
              <li v-for="(rol, index) in record?.roles || []" :key="index" class="py-3">
                <i class="fas fa-shield-halved text-emerald-500 mr-4"></i>
                {{ rol }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import image from "@/assets/img/avatar.png";

export default {
  data() {
    return {
      image,
    };
  },

  props: {
    record: {},
  }
};
</script>
